import Compressor from "compressorjs";
import { MEDIA_URL } from "helpers/constants/urls";

interface UploadResponse {
  statusCode: number;
  data: { image: string; vehicleDetails?: VehicleDetails };
  message: string;
}

export interface VehicleDetails {
  isVehicle: string;
  make: string;
  model: string;
  year: string;
  color: string;
  view: string;
  description: string;
  specifications: Specifications;
}

export interface Specifications {
  bodyType: string;
  doors: string;
  interiorMaterial: string;
  sunroof: string;
  wheels: string;
  dashboard: string;
}

export const UploadMedia = (
  imageObject: any,
  car?: boolean
): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    new Compressor(imageObject, {
      quality: 0.6,

      success: async (compressedResult) => {
        const formData = new FormData();
        formData.append("file", compressedResult as any);

        const headers = {
          Accept: "application/json",
          "x-portal": "user",
        };
        let url = MEDIA_URL;
        if (car) {
          url = MEDIA_URL;
        }
        try {
          const res = await fetch(url!, {
            method: "POST",
            headers,
            body: formData,
          });
          const response = await res.json();
          resolve(response);
        } catch (error) {
          reject(error);
        }
      },
    });
  });
};

// export const UploadMedia = (imageObject: any): Promise<UploadResponse> => {
//   return new Promise(async (resolve, reject) => {
//     new Compressor(imageObject, {
//       quality: 0.5,
//       success: async (compressedResult) => {
//         const formData = new FormData();
//         formData.append('file', compressedResult as any);
//         const headers = {
//           Accept: 'application/json',
//         };

//         try {
//           const res = await fetch(media_url, {
//             method: 'POST',
//             headers,
//             body: formData,
//           });
//           const response = await res.json();
//           resolve(response); // Resolve the Promise with the response
//         } catch (error) {
//           console.error(error, '>>>>>>>>>');
//           reject(error); // Reject the Promise with the error
//         }
//       },
//     });
//   });
// };
export const UploadVideo = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append("file", imageObject as any);
    const headers = {
      Accept: "application/json",
    };

    try {
      const res = await fetch(MEDIA_URL!, {
        method: "POST",
        headers,
        body: formData,
      });
      const response = await res.json();
      resolve(response); // Resolve the Promise with the response
    } catch (error) {
      console.error(error, ">>>>>>>>>");
      reject(error); // Reject the Promise with the error
    }
  });
};

export const Uploadpdf = async (imageObject: any) => {
  const formData = new FormData();

  formData.append("file", imageObject as any);
  const headers = {
    // "Content-Type": "multipart/form-data",
    Accept: "application/json",
    "x-portal": "user",
  };
  try {
    const res = await fetch(MEDIA_URL!, {
      method: "POST",
      headers,
      body: formData,
    });
    const response = await res.json();
    return response;
  } catch (error) {
    console.error(error, ">>>>>>>>>");
    return error;
  }
};
